import constants from '../../constants/app-constants';

export const toggleProfileModal = (modalVisibility) => {
  return {
    type: constants.client.PROFILE_TOGGLE_MODAL,
    payload: modalVisibility
  };
};